import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Button,
  CssBaseline,
  Typography,
  Container,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

// Components
import Footer from "../layout/Footer";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(12),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.primary.light,
  },
  submit: {
    width: "60%",
    padding: "10px",
    margin: theme.spacing(5, 0, 2),
    "&:hover": {
      color: "white",
    },
  },
}));

const ResetSucceeded = () => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />

      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5" align="center">
          Your password has been reset.{" "}
        </Typography>
        <Button
          size="large"
          variant="contained"
          color="primary"
          type="submit"
          className={classes.submit}
          component={Link}
          to="/login"
        >
          Sign In Now{" "}
        </Button>{" "}
      </div>

      <Footer />
    </Container>
  );
};

export default ResetSucceeded;
